var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconQr = function SvgMiconQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M24 26v2h2v-2zM18 22v2h2v-2zM18 30h4v-2h-2v-2h-2zM26 22v4h2v-4zM28 26h2v4h-4v-2h2zM26 20v-2h4v4h-2v-2zM24 20h-2v4h-2v2h4zM18 18v2h4v-2zM10 22H6v4h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M14 30H2V18h12zM4 28h8v-8H4zM26 6h-4v4h4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M30 14H18V2h12zm-10-2h8V4h-8zM10 6H6v4h4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M14 14H2V2h12zM4 12h8V4H4z"
  })));
};
export default SvgMiconQr;